import { Alert, AlertTitle } from '@/global/components/Alert'
import { GridCellParams } from '@/global/components/DataGrid/utils/types'
import { Badge } from '@/global/components/ui/badge'
import { Tooltip } from '@/global/components/ui/tooltip'
import { cn } from '@/lib/utils'
import dayjs from 'dayjs'
import Menu from 'global/components/Menu'
import { useRef } from 'react'
import { LogCalculos } from 'service/api'

const notificacoes = (row: any) => {
    if (!row)
        return {
            quantidade: 0,
        }
    const logsLength = row.logs?.length ?? 0
    const hasFeriado = Boolean(row.feriado)
    const n = hasFeriado ? logsLength + 1 : logsLength
    let res = n
    if (row.logs?.find((log: any) => log.titulo === 'Admissão'))
        res = n - 1 > 0 ? n - 1 + ' A' : 'A'
    if (row.logs?.find((log: any) => log.titulo === 'Rescisão'))
        res = n - 1 > 0 ? n - 1 + ' R' : 'R'
    return {
        quantidade: n,
        texto: res,
    }
}

export function ExibirDia({ row, value }: GridCellParams) {
    const clickRef = useRef<HTMLDivElement>(null)

    const Display = (
        <div
            title={
                row.feriado ? `Feriado ${row.feriado.nome ?? ''}` : undefined
            }
            className="flex flex-col justify-evenly h-fit"
            ref={clickRef}
        >
            <span className="text-base/5 uppercase text-muted-foreground">
                {dayjs(value).format('ddd')}
            </span>

            <span className="relative text-base/5 font-bold">
                {dayjs(value).format('DD/MM')}
            </span>
        </div>
    )

    return (
        <div className="h-full flex items-center overflow-visible relative">
            {!!row.justificativa && (
                <Tooltip
                    title={`Dia alterado manualmente: ${row.justificativa}`}
                    className="w-sm break-all"
                >
                    <div className="absolute -left-2.5 top-0 h-full w-4/5 flex items-start justify-start">
                        <div className="h-full w-1.5 bg-warning cursor-help" />
                        <div className="flex-1 z-2" />
                    </div>
                </Tooltip>
            )}
            <Badge
                className={cn(
                    'absolute top-1.5 -right-2 size-5 select-none cursor-pointer',
                    getColor(row, true),
                )}
                onClick={() => {
                    clickRef.current?.click()
                }}
            >
                {notificacoes(row).quantidade > 0
                    ? notificacoes(row).texto
                    : null}
            </Badge>
            {notificacoes(row).quantidade > 0 ? (
                <Menu.Root position="left">
                    <Menu.Trigger pointer>{Display}</Menu.Trigger>
                    <Menu.List className="p-0">
                        {row.feriado && (
                            <Alert
                                className="min-w-[400px]"
                                severity="info"
                                key="feriado"
                            >
                                <AlertTitle>Feriado</AlertTitle>
                                {row.feriado.nome}
                            </Alert>
                        )}
                        {row.logs?.map((log: LogCalculos, i: number) => (
                            <Alert
                                severity={getColor<
                                    'success' | 'info' | 'warning' | 'error'
                                >({ logs: [log] })}
                                key={i}
                            >
                                <AlertTitle>{(log as any).titulo}</AlertTitle>
                                {log.descricao}
                            </Alert>
                        ))}
                    </Menu.List>
                </Menu.Root>
            ) : (
                Display
            )}
        </div>
    )
}

function getColor<T extends string>(row: any, badge?: boolean): T | undefined {
    let type: string
    if (row.logs?.length) {
        if (row.logs.some((log: LogCalculos) => log.variante === 'error')) {
            type ??= 'error'
        } else if (
            row.logs.some((log: LogCalculos) => log.variante === 'warning')
        ) {
            type ??= 'warning'
        } else if (
            row.logs.some((log: LogCalculos) => log.titulo === 'Rescisão')
        ) {
            type ??= badge ? 'primary' : 'info'
        } else if (
            row.logs.some((log: LogCalculos) => log.variante === 'info')
        ) {
            type ??= 'info'
        } else if (
            row.logs.some((log: LogCalculos) => log.variante === 'success')
        ) {
            type ??= 'success'
        }
    } else if (row.feriado) {
        type ??= 'info'
    }

    type ??= ''
    switch (type) {
        case 'error':
            return badge ? ('bg-error' as T) : ('error' as T)
        case 'warning':
            return badge ? ('bg-warning' as T) : ('warning' as T)
        case 'info':
            return badge ? ('bg-info' as T) : ('info' as T)
        case 'primary':
            return badge ? ('bg-primary' as T) : ('info' as T)
        case 'success':
            return badge ? ('bg-success' as T) : ('success' as T)
        default:
            return undefined
    }
}
